import { Navigate, Outlet, useLocation } from "react-router-dom";
import NotFound from "../pages/auth/NotFound";
import AccessDenied from "../pages/auth/AccessDenied";
import { useChatSocket } from "../hooks/useChatSocket";
import useAuthStore from "../store/authStore";

const KNOWN_PREFIXES = [
  "/admin/",
  "/manager/",
  "/employee/",
  "/login",
  "/forgot-password",
  "/reset-password",
];

const PrivateRoute = ({ allowedRoles }) => {
  const token = useAuthStore((state) => state.token);
  const role = useAuthStore((state) => state.role);
  const mustChangePassword = useAuthStore((state) => state.mustChangePassword);
  const location = useLocation();

  useChatSocket();

  if (!token) {
    const publicPaths = ["/login", "/forgot-password", "/reset-password"];
    if (publicPaths.some((path) => location.pathname.startsWith(path))) {
      return null;
    }

    const isKnownRoute = KNOWN_PREFIXES.some((prefix) =>
      location.pathname.startsWith(prefix)
    );
    if (isKnownRoute) {
      return <Navigate to="/login" replace />;
    }
    return <NotFound />;
  }

  if (mustChangePassword) return <Navigate to="/reset-password" replace />;

  if (allowedRoles && !allowedRoles.includes(role)) return <AccessDenied />;

  return <Outlet />;
};

export default PrivateRoute;